var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.07088 1.11234C9.41462 0.295885 10.5854 0.295886 10.9291 1.11235L12.9579 5.93123C13.1029 6.27543 13.4306 6.51061 13.8067 6.5404L19.0727 6.95748C19.9649 7.02814 20.3267 8.12813 19.6469 8.7034L15.6348 12.0987C15.3482 12.3412 15.223 12.7218 15.3106 13.0843L16.5363 18.161C16.744 19.0211 15.7969 19.701 15.033 19.2401L10.5245 16.5196C10.2025 16.3252 9.7975 16.3252 9.47548 16.5196L4.96699 19.2401C4.20311 19.701 3.25596 19.0211 3.46363 18.161L4.68942 13.0843C4.77698 12.7218 4.65182 12.3412 4.36526 12.0987L0.353062 8.7034C-0.326718 8.12813 0.0350679 7.02814 0.927291 6.95748L6.19336 6.5404C6.5695 6.51061 6.89716 6.27543 7.04207 5.93123L9.07088 1.11234Z",
    fill: "#F5A575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.419b04caec024b25d9bb7b34550bdc84.svg";
export { ForwardRef as ReactComponent };